module.exports = __webpack_public_path__ + "static/img/logo-patrim.d52ef96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-patrim.svg
// module id = 352
// module chunks = 1